import cover from "../../assets/pic1.png";
export const source = () => {
  const result = [
    {
      title: "Prepared By",
      details: {
        html: `
        <h4>Prepared By:</h4>
        <ol>
        <li>Dr. Mengistu Gebreyohanes, Orthopedic Surgeon,
        Spine Surgery Sub specialist</li>
        
        <li>Dr. Ephrem Gebrehana, Orthopedic Surgeon, Trauma
        and Arthroplasty Sub specialist</li>
      </ol>
      <div style="padding-left: 30%;">
      <p>Hawassa, Ethiopia<br> 2016 G.C</p>
      </div>
      <table>
  <tr>
    <th>Application development</th>
    <th>Sponsor</th>
    </tr>
    <tr>
    <td>Ermias KUrabachew <br>+251 92 250 0469</td>
    <td>AO Alliance</td>
    </tr>
    </table>

    `,
      },
      image: "bosad_poster",
    },
    {
      title: "Copyright",
      details: {
        html: `
        <h3>Copyright © 2023 by the Ethiopian BOSAD Research Team. All rights reserved.</h3>
      <h4>All right reserved 2023 G.c</h4>
      <p  style="padding-right: 10px;">
        Printed in Ethiopia.
        Except as permitted under Proclamation No. 410/2004, as amended by Proclamation No. 872/2014, no part of this
        publication may be reproduced or distributed in any form or by any means or stored in a database or
        retrieval system without the prior written permission of the Ethiopian BOSAD Research Team.
      </p>
      <p  style="padding-right: 10px;">
        This school children booklet focused on unintentional fall, prevention
        strategy and pre-hospital Management of unintentional fall in school
        children is prepared on behalf of the BOSAD study group, and the data
        was compiled from this national study report.
      </p>
      <p>Layout design and Illustration by: Dess Advert</p>
      If you want to give any suggestion or feedback,
          please use the following address. Dr. Mengistu Gebreyohanes; telephone number:
          +251910120423 or Email address: mengistugmengesha@gmail.com`,
      },
    },
    {
      title: "Acknowledgement",
      details: {
        html: `
        <p style="padding-right: 10px;">
        Major thanks to the BOSAD research team and skilled language translators
        for their translational work into different languages. Special recognition to
        Drs. Hizkyas Kassaye, Araya Tilahun, Tolasa Dinsa, Abdullahi Mohamed,
        and Mrs. Eden Alemu (BOSAD study coordinator) for their valuable contributions in reviewing the document
      </p>
      <ol>
        <li>
          Dr. Mengistu Gebreyohanes Mengesha, Orthopedic Surgeon, Spine Surgery Sub specialist
        </li>
        
        <li>
          Dr. Ephrem Gebrehana Adem, Orthopedic Surgeon, Trauma
          and Arthroplasty Sub specialist
        </li>
      </ol>`,
      },
    },
    {
      title: "INTRODUCTION",
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
        Given the lack of educational materials focusing on preventing unintentional falls and offering pre-hospital care for school age children, the number of children experiencing falling accidents are unfortunately common. To bridge this gap, this booklet has been developed in different languages by experts involved in the national multicenter study called BOne Setting Associated Disability (BOSAD) study in Ethiopia and Gambia. The aim of this study is to prevent complications arising from musculoskeletal injuries managed with tight bandaging, bamboo splinting and repetitive massaging. The whole aim of this BOSAD researcher team is to improve the holistic care given for all musculoskeletal injury throughout the country.
        </p>
        <p style="padding-right: 10px;">
        Over the past 18 months of the study, numerous school age children experienced falling accidents at school. Subsequently, they were taken to nearby traditional bone setters where they received bamboo splints, massages, and stayed home for 7 to 14 days. Then when the pain is not relieved and the family noticed as the condition get worse, they brought them to health facilities for further evaluation and management. Upon evaluation either they will have gangrenous limb which is non salvageable and end up with amputation or permanent irreversible damage which will develop into permanent disability. As an Orthopedic surgeon this is the bad truth that we face in our daily activities. If the children were presented to health facilities timely and managed appropriately after falling injury, it would have been nice to manage them appropriately and they will return back to their schooling with good health.
        </p>
        <p style="padding-right: 10px;">
        The primary motivation behind preparing this school children’s booklet is to raise awareness about falling injuries and provide preventive strategies. Although falls may not always be avoidable, ensuring a safe and appropriate care package for injured children can significantly mitigate further injury and hasten recovery. This school children booklet will outline comprehensive pre-hospital management for injured children, enabling school teachers, families, and children themselves to understand and apply these measures in the event of a fall.
        As we all know children are not small adults. They possess distinct physical and cognitive abilities, dependency levels, activities and risk behaviours compared to adults. Therefore, this independent booklet is prepared specifically focussing on Children’s fall related injuries.
        </p>
      </div>
      `,
      },
    },
    {
      title: "AIM OF THE BOOKLET",
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">The main purpose of this booklet is to provide information for school children themselves,
        families, school teachers, caregivers, school media personnel like mini media and all the communities at large about risk factors for children’s falling injuries at school, how to prevent it and management approach mainly at pre-hospital care. The booklet is translated into different languages in Ethiopia and distributed for schools and families if possible.
        </p>
      </div>`,
      },
    },
    {
      title: "DEFINITIONS",
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
          <b>Children:-</b> In this booklet, we used the term “children” to refer to those individuals who are under the age of 18 years. By default, all children who are attending their class until grade 12th are included in under the umbrella of children
        </p>
        <p style="padding-right: 10px;">
          <b>Fall or falling down accident:-</b>Is unplanned and sudden descent to the ground, the floor and lower level which may result in injury to the individual.
        </p>
        <p style="padding-right: 10px;">
          <b>Injury or trauma:-</b> In this booklet, the terms “injury” and “trauma” are used interchangeably to denote physical harm to living body tissues resulting from unintentional physical stress.
        </p>
      </div> `,
      },
    },
    {
      title:
        "WHY IT IS IMPORTANT TO TALK ABOUT UNINTENTIONAL FALL IN SCHOOL CHILDREN?",
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>
          According to WHO report, in children up to the age of 18 years, injury is one of the 3 top causes of death and permanent disability.
          </li>
          
          <li>
          In most resource limited countries, falls are the most common type of childhood injury seen in emergency departments, accounting for 25 - 52% of all trauma mechanisms.
          </li>
          
          <li>
          One of the main reasons for school dropout is fall related morbidity and permanent disability
          </li>
          
          <li>
          Falls result in high social and economic costs to families and the communities at large due to hospitalization.
          </li>
          
          <li>
          Falls are the fourth leading cause of trauma deaths in childhood in the United States and this will be much worse in our country which might be three times higher
          </li>
          
          <li>
          From our experience here in Ethiopia, Pediatric patients are most commonly complicated after falling accident. Nearly 17 % of limb amputation done in Hawassa university over the past 3 years is on paediatric patients after they sustain minor trauma and get tight bandage application and develop gangrenous limb.
          </li>
          
        </ol>
      </div>
      `,
      },
      image: 1,
    },
    {
      title: "WHY CHILDREN SUSTAIN UNINTENTIONAL FALL INJURY IN SCHOOL?",
      details: {
        html: `
        <div class="chapter-content">
        <p>
        Falling is a normal part of the way a child develops and grows – learning to walk, climb, run, jump and explore the physical environment. Fortunately, most falls will have little consequence and most children fall many times in their lives without major damage other than a few cuts and bruises. There are some selected areas where the child may sustain fall down accident in school which includes:
        </p>
        <ol>
          <li>
          Young children may fall from childcare equipment like nursery furniture and baby walker
          </li>

          <li>Others may fall from playground equipment
          </li>

          <li>Fall from Rooftop</li>

          <li>Slippery or wet area fall specifically during the rainy seasons
          </li>

          <li>Climbing stairs and jump from open window fall
          </li>

          <li>New construction area falls inside the school</li>

          <li>Fall into ditches and wells in the school</li>

          <li>Sport and recreational activities like football, volleyball, and others</li>

          <li>Fall from tree- the child may climb a tree to collect fruit or just to play and sustain fall injury
          </li>

          <li>
          Fall from the back of animals like back of horse- in rural area, there is possibility for children to ride horse or donkey and present after sustaining falling injury
          </li>
          
          <li>
          Injuries caused by tackling or twisting by peers of the same age, especially in the ankle area, are more common.
          </li>
          
        </ol>
      </div>      `,
      },
      image: 2,
    },
    {
      title: "WHAT ARE THE CONSEQUENCES OF FALLING DOWN INJURY?",
      details: {
        html: `
        <div class="chapter-content">
        <p>
        The consequences of falling injury will be depending upon different factors including age of child, falling height or energy of trauma, speed of insulting energy, landing ground surface, and nature of the injury (either open- will have external bleeding at least or closed injury- without bleeding). These injuries could have lifelong disability which will be a big burden for the families and communities at large and in few cases, it will cause death.
        </p>
        <p>
        The magnitude of the injury from falling includes the following spectrums:-
        <ol>
          <li>Traumatic brain injury which may lead loss of consciousness</li>
          <li>Spinal cord injury which may lead to permanent disability</li>
          <li>Lifelong permanent disabilities including amputation</li>
          <li>Limb fracture (Upper and/or lower extremity fractures)</li>
          <li>Open fractures which will be complicated with infection</li>
          <li>Growth plate injury leading to angular deformity and permanent disability unless managed timely</li>
          <li>Abdominopelvic and chest trauma</li>
          <li>Irreversible hearing and sight loss as part of permanent disability</li>
          <li>Finally, there could be also death from high energy trauma or fall from significant height.</li>
        </ol>
        </p>
      </div>`,
      },
      image: 3,
    },
    {
      title: "HOW TO PREVENT UNINTENTIONAL FALL AND POST FALL COMPLICATIONS?",
      details: {
        html: `
        <div class="chapter-content">
        <p>Prevention is the best cost-effective way of managing all health-related
          conditions. Here, we tried to show what activities can be done at school
          level to prevent major fall related children’s injuries and provide cost
          effective treatment for all.
        </p>
        <ol>
          <li>As much as possible, the school need to prepare a
            <b>“children friendly” </b>school compound. When we say children
            friendly school compound, it doesn’t need a very sophisticated building, rather it just needs to make the compound very easy to walk
            through and safe for children, so that we can reduce fall accident
            from nursery furniture and baby walker.
          </li>
          <li>When the <b>playgrounds </b>(climbing, jumping and sliding equipment)
            at school are prepared and installed, they need to be evaluated for
            safety standard before it starts giving service, so that any
            child will not fall unnecessarily and get injured. The school need to
            have a mechanism to maintain the playground periodically and need to
            assign supervisors for younger children. The height should be appropriate
            for the child age; and landing surface of the playground need to be checked
            for regularity, safety and smooth landing surface.
          </li>

          <li>It is advisable for schools not to have an open rooftop where the
            children may go and fall accidentally. It is strictly advised to
            protect the rooftop, balcony and staircases in order to prevent
            accidental fall of children. It is also important to teach students
            about what to do and not to do regarding their safety in the school
            compound via mini media on their morning or evening gathering.
          </li>
          <li>The school compound needs to be clean and dry as much as possible by
            removing watery grounds like open drains and wells. These open watery
            areas are very dangerous as a cause of fall and may lead up to life
            threatening condition for everybody. So, it is crucial to remove any
            slippery ground from the school compound as much as possible by
            covering wells and ditches.
          </li>
          <li>The stairs where the children used to climb should be checked for
            safety and maintenance should be done regularly before it causes any
            injury.
          </li>
          <li>When there is new construction in the school compound, there should be clear prohibited zones for students not to come closer by showing clearly written instruction. In addition to this, it is also important to assign a supervisor who regularly follows if there is any student going to the prohibited danger area.
          </li>
          <li>During <b>sport or recreational activities, </b> it is advised for students to play with their age-matched peers in order to minimize high impact injury. The recreational place should be safe with smooth ground. Whenever applicable and possible,  the  students  need to use the proper safety equipment during playing such as knee pads, elbow pads, wrist guards, and helmets while playing sports
          </li>
          <li>Some children will try to climb on trees to collect fruit and vegetables and accidently sustain a fall down. Others may climb trees just to play with their peers and present to us with limb injury commonly open fractures. Whatever the aim of tree climbing, it should be prohibited for children unless it is under direct supervision from the school supervisor or other responsible personnel and safe to climb.
          </li>
          <li>Children, specifically the youngsters should not be allowed to ride Horse or donkey. They need to be educated about the risk associated if they sustain a fall which may even lead to death or permanent disabilities.
          </li>
          <li>It will be wise to guard all the windows in the school so that the child will not try to jump either intentionally or non-intentionally through the window and get injured. Now a days installation of window guard become a common practice for all school window doors and it has significant role in reducing fall injury.
          </li>
        </ol>
      </div>
      `,
      },
      image: "4English",
    },
    {
      title:
        "PRE-HOSPITAL MANAGEMENT PACKAGE FOR FALLEN CHILD IN THE SCHOOL COMPOUND",
      details: {
        html: `
        <div class="chapter-content">
        <p>Upon a child sustaining a fall injury, immediate action by bystanders becomes imperative to preserve the child’s life, mitigate additional injury,
          alleviate pain, prevent permanent disability and provide psychological
          support. This immediate intervention, commonly referred to as
          <b>“First Aid,” </b>plays a critical role in safeguarding the child’s life
          and substantial- ly enhancing subsequent outcomes.
        </p>
        <p>
        For effective provision of first aid within schools, it is crucial to have adequately trained personnel readily accessible on the premises equipped with first aid kits at all times. Establishing first aid centres and ensuring the availability of trained personnel across all schools is crucial. These centres should prioritize swift response and basic first aid measures, devoid of reliance on sophisticated instruments or materials.
        </p>
        <p>The following activities should be undertaken in order to give successful first aid for student who sustain fall down accident:</p>
        <ol>
          <li>In the event of a child falling, the immediate responder should vocally signal (Shout) for assistance, alerting those nearby to mobilize aid. Simultaneously, the responder should attend the child using available resources. If an individual trained in first aid is present, their immediate help is crucial. Within moments, life-saving measures such as proper positioning of the child, assessment of airway, breathing, and immediate mitigation of any life-threatening conditions must be initiated.
          </li>
          <li>Once it is confirmed that there are no immediate life-threatening conditions, a comprehensive whole body survey must be conducted. The child should be positioned on a flat surface, ideally  on a spine board if accessible, while being prompted to indicate the injury site or area of maximal pain. This thorough examination should encompass a head-to-toe assessment, aiming to identify any concealed or unnoticed injuries that the child might not have dis- closed initially.
          </li>
          <li>In order to diagnose limb fractures among musculoskeletal injuries, assessor can employ specific clinical indicators, known as “sure signs of fracture,” comprising the following findings:
          <ol type="a">
            <li> Intense pain localized at the injury sitec</li>
            <li>Noticeable deformity and Limb shortening compared to the unaffected side</li>
            <li>Evident external fracture (open fracture)</li>
            <li>Detectable or audible crepitus (avoid eliciting crepitus to prevent neurovascular injury)</li>
            <li>Abnormal movement at the injury site. Should the child exhibit any of these signs, immediate provision of comprehensive first aid is imperative, and urgent referral to a facility equipped to administer appropriate orthopedic services become of very important.</li>
          </ol>
          </li>
          <li>Upon identifying the injury site and suspecting a potential fracture
            or soft tissue injury, school personnel should promptly notify the
            child’s family. Simultaneously, the injured limb should be appropriately
            splinted based on the site of injury. Utilizing available resources
            within the school compound, temporary splinting methods can be
            employed to immobilize the limb effectively.
          </li>
        </ol>
        </p>
      </div>
      `,
      },
      image: 5,
    },
    {
      title: "WHAT YOU SHOULD DO WHEN YOU GIVE FIRST AID FOR FALLEN CHILD?",
      details: {
        html: `
        <div class="chapter-content">
        <p>The following steps are important to effectively immobilize the injured body part of a child who has experienced a falling accident:-
        </p>
        <ol type="a">
          <li>In the event of bleeding, utilize available towels from the first aid kits to stop the bleeding. In its absence, the child’s clothing or uni- form can be used. Prioritize to stop the bleeding over concerns of potential infection. When applying the towel, ensure it functions as a bulky dressing, avoiding tight wrapping that could impede cir- culation and exacerbate circulatory compromise. During the pro- cedure to stop the bleeding, take precautions to prevent personal contamination from blood
          </li>
          <li>As much as possible, remove all the clothes that surrounds the in- jured limb of the child.
          </li>
          <li>If there is suspicion of a spine (back) injury, the child should re- main immobilized unless cleared at the hospital. Moving or rolling the child could potentially exacerbate the injury.
          </li>
          <li>Avoid attempting to reposition or manipulate the injured limb un- less there is a noticeable and significant visible deformity. Doing so could potentially cause additional unnecessary damage and inflict severe pain on the child. Instead, immobilize the limb in its current position. If there is no movement, sensation, or pulsation distal to the injury site, consider slight repositioning of the limb in order to facilitate nerve function and circulation.
          </li>
          <li>While providing support to the injured limb, seek assistance from someone nearby to help immobilize it.
          </li>
          <li>You may utilize any straight and rigid object such as a wooden board, sturdy sticks, cartons, or cardboard for splinting. The crucial aspect is to ensure the splint is appropriately sized to fit the injured limb.
          </li>
          <li>When applying the splint, aim to immobilize the two neighbouring (adjacent) joints or bones closest to the injury site.
          </li>

          <li>Avoid applying a tight bandage or wrapping that might worsen cir- culation
          </li>
          <li>During splinting, ensure a 10-15 degree bend at the knee joint, a 90 degree angle at the ankle and elbow, and maintain a straight position for the hip and wrist.
          </li>
          <li>Secure the splint by wrapping or tying it to the injured limb. You can utilize the previously removed cloth to fasten the splint in place.
          </li>
          <li>Arrange immediate referral of the child to nearby healthcare facili- ties where they can receive definitive medical management.
          </li>
          <li>It would be beneficial if someone who witnessed the child’s fall or was involved in administering first aid accompanies the child and facilitates the handover to the healthcare facility service provider.
          </li>
        </ol>
      </div>
      `,
      },
      image: 6,
    },
    {
      title: "WHAT YOU SHOULD NOT DO WHEN YOU GIVE FIRST AID FOR FALLEN CHILD?",
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>Don’t undermine falling down injury in children. For any child ex- periencing a fall from a height, sustaining trauma during sports activities, or high energy impact, alongside complaints of pain at the injury site or crying after the accident, it’s crucial not to undermine the injury and send the child home. Children’s bone structure differs significantly from adults’, making them more susceptible for the following unique type of pediatric fractures:
          <ol type="a">
            <li>Growth plate injuries</li>
            <li>Greenstick fractures</li>
            <li>Torus fractures</li>
            <li>Plastic deformities. These patterns of fractures are distinct from adult fractures. Hence, until ruled out by an orthopedic surgeon, such cases should be treated with the assumption that the child may have a fracture.</li>
            </ol>
          </li>
          <li>Don’t massage, manipulate or send fallen child to traditional bone setters. All children who sustain fall injury MUST be evaluated with an appropriately trained Orthopedic surgeon. Children are easily viable for complications including gangrene, vascular injury, deformity and malunion. In addition, children’s fractures are difficult to diagnose and identify unless they are properly X-rayed and examined by trained medical professionals. Trying to massage or move the affected part of the child’s body might be one of the worst pains that a person can expe- rience in life and it may cause fainting of the child. This type of manip- ulation should be prohibited at all.
          </li>
          <li>Don’t apply tight bandages. Applying a tight bandage to an already injured limb can significantly impair circulation, potentially leading to a gangrenous limb. Therefore, whenever possible, splints should avoid circular application and be loosely fitted to adequately support the limb.
          </li>
          <li>Don’t apply a tourniquet to  stop  bleeding. Application  of  tourniquet to stop bleeding in the injured limb will compromise blood flow. So, whenever you plan to stop bleeding, just apply bulky dressing and el- evation of the extremity. Then refer the patient immediately to health facilities.
          </li>
        </ol>
      </div>
      `,
      },
      image: 7,
    },
    {
      title: "WHOM, WHEN AND HOW TO REFER FALLEN CHILD TO HEALTH FACILITIES?",
      details: {
        html: `
        <div class="chapter-content">

        <p>Whom to refer? For any child who sustain fall down injury and having one of the following should be immediately referred to health facilities:
        </p>
        <ol type="1">
          <li>Any bleeding wound after the trauma</li>
          <li>Presence of one of sure sign of fracture mentioned above</li>
          <li>If you have suspicion of anybody region injury</li>
          <li>Presence of pain, tenderness and swelling at the injury site</li>
          <li>Difficulty of use of the injured limb</li>
          <li>For younger child, if they cry persistently after the trauma</li>
        </ol>
        <p>When to refer the fallen child? Children who sustain injuries from falls shall receive immediate first aid at the site and undergo a specific obser- vation period. In cases where the trauma isn’t minor and the child cannot resume normal activities such as returning to class or playing, immediate referral is imperative. Post Trauma, timely referral facilitates prompt di- agnosis, ensures early management, and leads to favourable outcomes. Thus, avoid unnecessary delays in referring fallen children for timely diagnosis and appropriate care.
        </p>
        <p>How to refer this child? Initially, administer all feasible life-and limb-saving first aid measures at the school level. Subsequently,  noti-  fy the families regarding the child’s condition, and facilitate the child’s transfer to a healthcare facility accompanied by the family or caregiver. Additionally, designate one representative from the school to accompany and facilitate the handover at the healthcare facility.
      </div>
      `,
      },
      image: "8English",
    },
    {
      title: "WHAT ARE THE CRITICAL ELEMENTS OF DEFINITIVE MANAGEMENT PACKAGE?",
      details: {
        html: `
        <div class="chapter-content">
        <p>In the case of injured child, the definitive care starts at the scene of the accident as any trauma victims. Then the child needs to be transferred to appropriate health facilities and all the routines should be given which includes the following major activities:
        </p>
        <ol type="1">
          <li>The child will be assessed for any life-threatening injury and managed accordingly. The approach for any trauma patient fol- lows the Advanced Trauma Life Support guidelines
          </li>
          <li>Then, based on the type of injury, different medications like an- algesia, antibiotic, tetanus antitoxin, and antiseizure medication will be administered based on the indication.
          </li>
          <li>If there is a wound, it will be cleaned in sterile fashion and covered with sterile gauze after stopping the bleeding.
          </li>
          <li>Whenever there is clear deformity and dislocation, it will be re- duced after giving adequate and appropriate medication to make the child pain free.
          </li>
          <li>The limb will be splinted appropriately respecting principles of splinting
          </li>
          <li>Then the patient will be sent for appropriate x-ray imaging. Here one of the most important things that you need to know is pedi- atric patient fractures are unique than adult fracture patterns, so the x-ray that we need to diagnose the problem might be different (both extremity x-ray might be be taken for comparison due to the presence of open growth plate) and interpretation will also need meticulous evaluation. So, everybody who can see x-ray will not pick the finding of some of the pediatric fracture, it really needs being expertise on it. Since there are a lot of traditional bone setters that expose children for unnecessary problems including gangrene by repeatedly massaging and tightly bandaging (tying) them after they order x-rays without any training on how to inter- pret x-rays. So, all parents have the responsibility and obligation to ensure that the treatment given to their fallen children is by a trained medical professional.
          </li>
          <li>Based on the clinical and x-ray finding, the definitive manage- ment of the child will be discussed with the families or care giv- er and decision will be passed either non operative or operative management
          </li>
          <li>In general, most of the pediatric injuries are managed with non-op- erative methods which actually need expert to apply it appropri- ately and their outcome is generally good. It needs close follow up and the whole aim of managing the fallen child is to manage timely, rehabilitate fast and return back for schooling. By doing this all, it is possible to reduce school dropout and absenteeism.
          </li>
        </ol>
      </div>
      `,
      },
      image: 9,
    },
    {
      title: "REFERENCES",
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>World Health Organization (WHO).Injuries and Inequities-Guidance forAddressing Inequities in
            unintention-al Injuries. Copenhagen, Denmark:World Health Organization RegionalOfﬁce for Europe; 2014</li>
          
          <li>CDC, Injuries among Children andTeens report, https://www.cdc.gov/injury/features/child-injury/index.html
          </li>
          <li>Chapman RL, Buckley L, SheehanM, Shochet IM. Pilot evaluation ofan adolescent risk and injury pre-vention
            programme incorporatingcurriculum and school connected-ness components. Health Educ Res.2013;28(4):612–625
          </li>
          <li>James S.L, Lucchesi L.R, BisignanoC, Castle C.D, Dingels Z.V, et al.The global burden of falls: Global,
            re-gional and national estimates of mor-bidity and mortality from the GlobalBurden of Disease Study 2017.
            InjuryPrev. 2020, 26 (Suppl. 1), i3–i11</li>
          <li>Amy E Peden, Richard C Franklin,Child Injury Prevention: Is it time toaddress the determinants of
            Health.Children, 2021, 8:46.</li>
          <li>International Federation of Red crossand Red crescent Societies, Interna-tional First aid and
            Rescessitationguidelines, 2016</li>
          <li>Meghalaya State Disaster Man-agement Authority, Basic First AidManual, India, 2014</li>
          <li>Blake G, Velikonja D, Pepper V,Jilderda I, Georgiou G. Evaluating an in-school injury
            preventionprogramme’s effect on children’shelmet wearing habits. Brain Inj.2008;22(6):501–507</li>
          <li>Pickett, W.; Molcho, M.; Simpson,K.; Janssen, I.; Kuntsche, E.; Ma-zur, J.; Harel, Y.; Boyce, W.F.
            Crossnational study of injury and socialdeterminants in adolescents. InjuryPrev. 2005, 11, 213–218</li>
          <li>Lama Bou-Karroum, Fadi El-Jardali,Mathilda Jabbour, Aya Harb, RachaFadlallah, et al, Preventing
            Unin-tentional Injuries in School-AgedChildren: A Systematic Review.Paediatrics, 2022, 149:6</li>
          <li>UNICEF. Levels & Trends in ChildMortality Report 2019. New York,NY: UNICEF; 2020</li>
          <li>Jamison DT, Breman JG, MeashamAR, et al. Disease Control Prioritiesin Developing Countries. Washing-ton,
            DC: The World Bank; 2006</li>
          <li>Barcelos RS, Del-Ponte B, SantosIS. Interventions to reduce accidentsin childhood: a systematic review.
            JPediatr (Rio J). 2018;94(4):351–367</li>
          <li>Mytton J, Towner E, Brussoni M,Gray S. Unintentional injuries inschool-aged children and
            adolescents:lessons from a systematic review ofcohort studies. Inj Prev.2009;15(2):111–124</li>
          <li>Mock CN, Smith KR, Kobusingye O,et al. Injury Prevention and Environ-mental Health: Key Messages. 3rded.
            Disease Control Priorities. Vol 7.Washington, DC: The World Bank;2017</li>
          <li>Nauta J, van Mechelen W, OttenRHJ, Verhagen EALM. A system-atic review on the effectivenessof school and
            community-basedinjury prevention programmes onrisk behaviour and injury risk in 8-12year old children. J Sci
            Med Sport.2014;17(2):165–172</li>
          <li>Kendrick D, Mulvaney CA, YeL, Stevens T, Mytton JA, Stew-art-Brown S. Parenting interventionsfor the
            prevention of unintentionalinjuries in childhood. Cochrane Data-base Syst Rev. 2013;(3)</li>
          <li>Towner E, Dowswell T, Jarvis S.Updating the evidence. A systematicreview of what works in
            preventingchildhood unintentional injuries: part1. Inj Prev. 2001;7(2):161–164</li>
          <li>Kendrick D, Young B, Mason-JonesAJ, et al. Home safety education andprovision of safety equipment
            forinjury prevention. Cochrane DatabaseSyst Rev. 2012;(9)</li>
          <li>Pearson M, Garside R, Moxham T,Anderson R. Preventing unintentionalinjuries to children in the home:
            asystematic review of the effective-ness of programmes supplying and/or installing home safety
            equipment.Health Promot Int. 2011;26(3):376–392</li>
          <li>Pearson M, Hunt H, Garside R, Mox-ham T, Peters J, Anderson R. Prevent-ing unintentional injuries to
            children under 15 years in the outdoors: asystematic review of the effectivenessof educational programs. Inj
            Prev.2012; 18(2):113–123</li>
          <li>Orton E, Whitehead J, Mhizha-Mu-rira J, et al. School-based educationprogrammes for the prevention
            ofunintentional injuries in children andyoung people. Cochrane DatabaseSyst Rev. 2016;(12):CD010246</li>
          <li>Morrongiello BA, Lasenby-LessardJ. Psychological determinants of risktaking by children: an
            integrativemodel and implications for interven-tions. Inj Prev. 2007;13(1):20–25</li>
          <li>DelCastillo-Andres O, Toronjo-Hor-nillo L, Toronjo-Urquiza L. Effectsof fall training program on
            autom-atization of safe motor responsesduring backwards falls in school-agechildren. Int J Environ Res
            PublicHealth. 2019;16(21)</li>
          <li>WHO, Falls, Key facts, 2021, https://www.who.int/news-room/fact-sheets/detail/falls</li>
        </ol>
      </div>
        `,
      },
    },
  ];
  return result;
};
